import React, { useState } from "react";
import Dashboard from "./Dashboard";
import PendingPayments from "./PendingPayments";
import Notifications from "./Notifications";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { getEnvVar } from "utils/env";
import NotificationsIndicator from "./Notifications/Indicator";
import Header from "components/common_components/Header";
import { Tabs } from "components/common_components/Tabs";

const getOptions = (user, match) => {
    const taskIdToPreload = match && match.params && match.params.id;
    const options = [
        { index: 0, label: "Work", path: "/home/work", icon: "customers", component: <Dashboard taskIdToPreload={taskIdToPreload} /> },
    ];

    if (user && user.canManagePayments) {
        options.push({
            index: options.length,
            label: "Pending Payments",
            path: "/home/pending-payments",
            icon: "payments",
            component: <PendingPayments />,
        });
    }

    if (user && user.canChatWithClients) {
        options.push({
            index: options.length,
            label: "Notifications",
            path: "/home/notifications",
            icon: "notification",
            component: <Notifications />,
            notificationsKeyIdentity: getEnvVar("REACT_APP_CHAT_IDENTITY"),
        });
    }

    return options;
};

function Home({ match }) {
    const { user } = useSelector((state) => state.Login);
    const [selectedOption, setSelectedOption] = useState(getOptions(user, match)[0]);

    function handleChange(_, newIndex) {
        const newSelectedOption = getOptions(user, match).find((o) => o.index === newIndex);
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }

    const renderTabLabel = (label, notificationsKeyIdentity) => {
        if (notificationsKeyIdentity) {
            return (
                <>
                    {label}
                    <NotificationsIndicator id="home" identity={notificationsKeyIdentity} className="in-tab" />
                </>
            );
        }
        return label;
    };

    return (
        <>
            <Header title="Home" />
            <Tabs
                options={getOptions(user, match)}
                selectedOption={selectedOption}
                onChange={handleChange}
                renderTabLabel={renderTabLabel}
            />
        </>
    );
}

export default withRouter(Home);
